import React, { useEffect, useMemo, useState } from "react";
import "./ReportTableComponent.css";
import { toast } from "react-toastify";
import { ArrowDownWideNarrow, Info, Search } from "lucide-react";

function ReportTableComponent({
  students,
  selectedStudents,
  setSelectedStudents,
  handleDownloadSubmit,
  isGettingData,
  setEmailDialog,
}) {
  const [showInfo, setShowInfo] = useState(false);
  const [searchItem, setSearchItem] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const filteredAndSortedStudents = useMemo(() => {
    let list = students.shortageStudents || [];
    // Filter
    list = list.filter((student) =>
      student?.student?.name?.toLowerCase().includes(searchItem?.toLowerCase()),
    );

    // Sort
    list = list.sort((a, b) => {
      const nameA = a?.student?.name?.toLowerCase();
      const nameB = b?.student?.name?.toLowerCase();
      return sortOrder === "asc"
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    });

    return list;
  }, [students, searchItem, sortOrder]);

  console.log("filteredAndSortedStudents", filteredAndSortedStudents);

  const paginatedStudents = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return filteredAndSortedStudents.slice(start, start + rowsPerPage);
  }, [filteredAndSortedStudents, currentPage, rowsPerPage]);

  console.log("paginatedStudents", paginatedStudents);

  const totalPages = Math.ceil(filteredAndSortedStudents.length / rowsPerPage);

  const handleSelectStudent = (id) => {
    if (selectedStudents.includes(id)) {
      setSelectedStudents(
        selectedStudents.filter((studentId) => studentId !== id),
      );
    } else {
      setSelectedStudents([...selectedStudents, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectedStudents.length === paginatedStudents?.length) {
      setSelectedStudents([]);
    } else {
      setSelectedStudents(
        paginatedStudents?.map((student) => student.student._id),
      );
    }
  };

  // useEffect(() => {
  //     if (students?.length === 0) {
  //         toast.error("There is no students record found!!")
  //     }
  // }, [students])

  const isAllSelected =
    paginatedStudents?.length > 0 &&
    selectedStudents.length === paginatedStudents?.length;

  const statusMap = {
    Present: "P",
    Absent: "A",
    Leave: "L",
    Delay: "D",
    "Not Taken": "NT",
  };
  const statusColors = {
    P: "blue",
    A: "red",
    L: "amber",
    D: "pink",
    H: "green",
    NT: "gray",
  };
  return (
    <div className="card">
      <div className="card-header-table">
        <div className="d-flex align-items-center gap-2">
          <div className="text-muted">
            <small className="poppins-semibold">
              Overall Class Attendance:
            </small>
            <small style={{ color: "#f77f00" }}>
              {" "}
              {students?.overallClassAttendancePercentage}% [Total Student
              Count: {students?.totalStudents}]
            </small>
          </div>
          <div className=" d-flex align-items-center gap-2">
            <button
              className="btn p-1 d-flex align-items-center shadow justify-content-center"
              onClick={() => setShowInfo(true)}
              style={{
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                fontSize: "14px",
                // background: "#f77f00",
                // color: "#fff",
                border: "none",
              }}
            >
              <Info size={14} />
            </button>
          </div>
        </div>
        {/* Search , sort , pagination */}
        <div className="d-flex align-items-center gap-2">
          <div className="input-group m-3" style={{ width: "300px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by name"
              value={searchItem}
              onChange={(e) => setSearchItem(e.target.value)}
            />
            <span className="input-group-text">
              <Search size={16} />
            </span>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div>
              {/* Sort Button */}
              <button
                className="d-flex align-items-center gap-2"
                style={{
                  height: "39px",
                  width: "145px",
                  fontWeight: 500,
                  fontSize: "14px",
                  background: "#F77F00",
                  borderRadius: "8px",
                  color: "white",
                  border: "none",
                  padding: "10px",
                }}
                onClick={() =>
                  setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                }
              >
                <ArrowDownWideNarrow size={16} />
                Sort by {sortOrder === "asc" ? "A - Z" : "Z - A"}
              </button>
            </div>

            <div className="d-flex align-items-center border rounded-2 p-1 gap-1 ">
              <label className="me-2">Rows Per Page</label>
              <select
                className="form-select"
                style={{ width: "70px" }}
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                {[5, 10, 20, 50].map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      {/* table UI */}
      <div
        className="table-container"
        style={{ height: "42vh", overflow: "scroll" }}
      >
        <table className="attendance-table">
          <thead
            style={{
              backgroundColor: "#ffd8be",
              position: "sticky",
              top: "0",
            }}
          >
            <tr style={{ fontSize: "14px" }}>
              <th>
                <div className="checkbox-header">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={() => handleSelectAll()}
                  />
                  <span>Sr.No.</span>
                </div>
              </th>
              <th>Roll Code</th>
              <th>Name</th>
              <th>
                {" "}
                <div>%</div>
                <span>Present/total</span>{" "}
              </th>
              {students?.classAttendancePerDay
                ?.slice()
                ?.sort((a, b) => new Date(a.date) - new Date(b.date))
                ?.map((data, idx) => (
                  <th key={idx}>
                    <div style={{ width: "75px" }}>
                      <span>{data?.date}</span>
                      <span>[{data?.day}]</span>
                      <span></span>
                      <div>
                        {data?.percentage}%[{data?.presentCount} /{" "}
                        {students?.totalStudents}]
                      </div>
                    </div>
                  </th>
                ))}
            </tr>
          </thead>

          <tbody>
            {isGettingData ? (
              <tr>
                <td colSpan={students?.classAttendancePerDay?.length + 4}>
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <img
                      src="/gif/LoaderDot.gif"
                      alt="Loading..."
                      style={{ width: "60px" }}
                    />
                    <span className="ms-2">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : paginatedStudents && paginatedStudents.length > 0 ? (
              paginatedStudents.map((student, index) => (
                <tr
                  key={index}
                  style={{
                    textAlign: "center",
                    backgroundColor:
                      (index + 1) % 2 === 0 ? "#ececec" : "white",
                  }}
                >
                  <td>
                    <div className="checkbox-cell">
                      <input
                        type="checkbox"
                        checked={selectedStudents.includes(
                          student?.student?._id,
                        )}
                        onChange={() =>
                          handleSelectStudent(student?.student?._id)
                        }
                      />
                      {index + 1}
                    </div>
                  </td>
                  <td>{student?.student?.code}</td>
                  <td>{student?.student?.name}</td>
                  <td>
                    {`${student.attendancePercentage}% [${student.presentDays} / ${student.totalDays}]`}
                  </td>

                  {students?.classAttendancePerDay
                    ?.slice()
                    ?.sort((a, b) => new Date(a.date) - new Date(b.date))
                    ?.map((attendance, idx) => {
                      const studentAttendance =
                        students?.studentsAttendancePerDay
                          ?.find((att) => att.date === attendance.date)
                          ?.students.find(
                            (stu) => stu.studentId === student.student._id,
                          );

                      const status = studentAttendance
                        ? statusMap[studentAttendance.status]
                        : "NT";

                      return (
                        <td
                          key={idx}
                          className={`status-cell ${statusColors[status]}`}
                        >
                          {status}
                        </td>
                      );
                    })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="no-data">
                  No Reported Students found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Action Buttons */}
      <div className="d-flex justify-content-end gap-2 py-1 px-2">
        <div className="actions-wrapper">
          <button
            className="action-button"
            style={{
              background:
                !selectedStudents?.length || isGettingData
                  ? "#fab973"
                  : "#F77F00",
            }}
            disabled={!selectedStudents?.length || isGettingData}
            onClick={handleDownloadSubmit}
          >
            Download
          </button>
          {/* needs to hide for now */}
          {/* <button
            className="action-button"
            style={{
              background:
                !selectedStudents?.length || isGettingData
                  ? "#fab973"
                  : "#F77F00",
            }}
            disabled={!selectedStudents?.length || isGettingData}
            onClick={() => setEmailDialog(true)}
          >
            Send Email
          </button> */}
        </div>
        <div className="d-flex justify-content-end align-items-center">
          <button
            className="btn btn-sm btn-outline-secondary me-2"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>
          <span className="me-3">
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      </div>

      {/* popup for info */}
      {showInfo && (
        <div
          className="modal d-block"
          tabIndex="-1"
          onClick={() => setShowInfo(false)}
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Attendance Info</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowInfo(false)}
                ></button>
              </div>
              <div className="modal-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <strong className="blue">P</strong> - Present
                  </li>
                  <li className="list-group-item">
                    <strong className="red">A</strong> - Absent
                  </li>
                  <li className="list-group-item">
                    <strong className="amber">L</strong> - Leave
                  </li>
                  <li className="list-group-item">
                    <strong className="pink">D</strong> - Delay
                  </li>
                  <li className="list-group-item">
                    <strong className="green">H</strong> - Holiday
                  </li>
                  <li className="list-group-item">
                    <strong className="gray">NT</strong> - Not Taken
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReportTableComponent;
